module.exports = __webpack_public_path__ + "img/icon_recenter_3.f692f796.svg";